import { Navigate, useParams, useRoutes } from "react-router-dom";
import ProtectedRoute from "./Components/protectedRoute";
// layouts

//

import Layout from "./layout/layout";
import EventPage from "./pages/eventPage";
import Home from "./pages/home";
import Profile from "./pages/profile";
import SearchPage from "./pages/searchPage";
import Confirmation from "./pages/confirmation";
import Organisateur from "./pages/organisateur";
import Categorie from "./Components/categorie";
import Article from "./Components/article";
import Cgp from "./Components/legacy/cgp";
import Cgu from "./Components/legacy/cgu";
import Login from "./pages/login";
import Affiliation from "./pages/dashboard/affiliationDetails";
import Paie from "./pages/paie";
import SignIn from "./pages/signin";
import Authenticate from "./pages/authenticate";

// ----------------------------------------------------------------------

export default function Router() {
  const params = useParams();
  return useRoutes([
    {
      path: "/",
      element: <Layout />,

      children: [
        { path: "/", element: <Navigate to="/home" /> },
        { path: "login", element: <Login /> },
        { path: "signin", element: <SignIn /> },
        { path: "authenticate", element: <Authenticate /> },
        { path: "onboarding", element: <SignIn /> },
        {
          path: "fr/profile",
          element: (
            <ProtectedRoute>
              <Profile />,
            </ProtectedRoute> 
          ),
        },
        {
          path: "onboarding",
          element: (
            <ProtectedRoute>
              <SignIn />,
            </ProtectedRoute> 
          ),
        },
        {
          path: "home",
          element: (
            <ProtectedRoute>
              <Home />,
            </ProtectedRoute> 
          ),
        },
        {
          path: "/affiliation/:affId",
          element: (
            <ProtectedRoute>
              <Affiliation />,
            </ProtectedRoute> 
          ),
        },
        {
          path: "paiement",
          element: (
            <ProtectedRoute>
              <Paie />,
            </ProtectedRoute> 
          ),
        },
      ],
    },

  ]);
}
